export default __webpack_public_path__ + "static/media/karachi.d883b87c.png";